<template>
  <v-list-item class="px-6 item">
    <template v-if="$slots.prepend" #prepend>
      <div class="me-4">
        <slot name="prepend" />
      </div>
    </template>
    <template v-if="$slots.title" #title>
      <v-list-item-title class="title">
        <slot name="title" />
      </v-list-item-title>
    </template>
    <slot />
  </v-list-item>
</template>

<style scoped>
.item {
  min-height: var(--space-7) !important;
}
.title {
  font-size: 14px;
}
</style>  